import {
  Box,
  Flex,
  Image,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import iconClose from "../../assets/images/projectManagement/icon-close.svg";

import { projectManagerCall } from "../../api/projectManager";
import { apartmentCall } from "../../api/apartment";
import { formatNumber } from "../../utils/utils";
import { employeeCall } from "../../api/employee";
import { useSelector } from "react-redux";
const REACT_APP_ROUTE_RATE =
  process.env.REACT_APP_ROUTE_RATE ||
  "MSH_RATE_PRODUCT_AND_APARTMENT_MANAGEMENT";
const PopupApartmentInfo = ({ isOpen, onClose, defaultValue, idData }) => {
  const user = useSelector((state) => state.auth.login?.currentUser);
  const [data, setData] = useState([]);
  const [getRoleUser, setGetRoleUser] = useState(false);

  const fetchDataUser = async (id) => {
    try {
      const res = await employeeCall.roleUser(id);
      if (res?.group_role_code) {
        const hasRole = res?.group_role_code
          ?.split(",")
          .includes(REACT_APP_ROUTE_RATE);
        setGetRoleUser(hasRole);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (idData) {
      const fetchData = async () => {
        try {
          const projectManager = await apartmentCall.getById(idData);
          if (projectManager) {
            setData(projectManager || []);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }

    if (defaultValue) {
      setData(defaultValue);
    }
  }, [idData, defaultValue]);

  useEffect(() => {
    fetchDataUser(user?.user?._id);
  }, [user?.user?._id]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        borderRadius={"16px"}
        maxW={"625px"}
        maxH={"88vh"}
        overflow="auto"
      >
        <Flex
          borderBottom={"1px solid var(--color-boder)"}
          alignItems={"center"}
          justifyContent={"space-between"}
          p={"24px 20px 24px 24px"}
        >
          <Text fontSize={"18px"} fontWeight={600} lineHeight={"normal"}>
            Chi tiết sản phẩm
          </Text>
          <Image src={iconClose} onClick={onClose} cursor={"pointer"} />
        </Flex>
        <Box p={"0px 40px 24px 40px"}>
          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Mã căn hộ
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.code || "-"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Tên căn hộ
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.name || "-"}
              </Text>
            </Box>
          </Flex>
          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Diện tích (m2)
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.area || "0"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Diện tích xây dựng (m2)
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.builtUpArea || "0"}
              </Text>
            </Box>
          </Flex>

          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Chiều dài (m)
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.length || "0"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Chiều rộng
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.width || "0"}
              </Text>
            </Box>
          </Flex>

          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Số phòng ngủ
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.numberOfBedrooms || "0"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Số phòng vệ sinh
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.numberOfToilets || "0"}
              </Text>
            </Box>
          </Flex>

          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Giá trị
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.totalValue
                  ? `${formatNumber(data?.totalValue || 0)} VNĐ`
                  : "0 VNĐ"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Giá tính PDV
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.priceForCommission
                  ? `${formatNumber(data?.priceForCommission || 0)} VNĐ`
                  : "0 VNĐ"}
              </Text>
            </Box>
          </Flex>

          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Hướng
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.direction?.name || "-"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Căn hộ
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.apartmentType?.name || "-"}
              </Text>
            </Box>
          </Flex>

          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Tính chất
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.property?.name || "-"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Phần khu
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.division?.name || "-"}
              </Text>
            </Box>
          </Flex>

          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Dự án
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.project?.name || "-"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Diện tích thông thủy (m2)
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.areaOfWater || "0"}
              </Text>
            </Box>
          </Flex>

          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Diện tích tim tường (m2)
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.grossFloorArea || "0"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Giá sau sản phẩm
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.estimatedServiceFeePrice
                  ? `${formatNumber(data?.estimatedServiceFeePrice || 0)} VNĐ`
                  : "0 VNĐ"}
              </Text>
            </Box>
          </Flex>

          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Hệ số k
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.kRate || "0"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Phần trăm thưởng nóng
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.hotBonusPercent || "0"} %
              </Text>
            </Box>
            {/* {getRoleUser && (
              <Box flex={1}>
                <Text
                  fontSize={"12px"}
                  lineHeight={"15px"}
                  color={"var(--color-label-employee)"}
                >
                  % phí dịch vụ nhận từ CĐT (X)
                </Text>
                <Text
                  mt={"8px"}
                  fontSize={"14px"}
                  lineHeight={"17px"}
                  fontWeight={500}
                  color={"var(--color-info-employee)"}
                >
                  {data?.commissionFromInvestor || "-"}
                </Text>
              </Box>
            )} */}
          </Flex>

          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Tỉ lệ thưởng nóng sàn (%)
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.rateTNSan || "0"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Tỉ lệ nhận về (%)
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.transactionRate || "0"}
              </Text>
            </Box>
          </Flex>

          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Số tiền TN sàn
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.priceTNSan
                  ? `${formatNumber(data?.priceTNSan || 0)} VNĐ`
                  : "0 VNĐ"}
              </Text>
            </Box>
          </Flex>
          {/* {getRoleUser && (
            <>
              <Flex mt={"16px"} w={"100%"} gap={"27px"}>
                <Box flex={1}>
                  <Text
                    fontSize={"12px"}
                    lineHeight={"15px"}
                    color={"var(--color-label-employee)"}
                  >
                    % phí dịch vụ trả cho sale (Y)
                  </Text>
                  <Text
                    mt={"8px"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={500}
                    color={"var(--color-info-employee)"}
                  >
                    {data?.commissionToSales || "-"}
                  </Text>
                </Box>
                <Box flex={1}>
                  <Text
                    fontSize={"12px"}
                    lineHeight={"15px"}
                    color={"var(--color-label-employee)"}
                  >
                    % phí dịch vụ nhận từ đối tác ngoài CĐT (Z)
                  </Text>
                  <Text
                    mt={"8px"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={500}
                    color={"var(--color-info-employee)"}
                  >
                    {data?.commissionFromPartner || "-"}
                  </Text>
                </Box>
              </Flex>
            </>
          )} */}
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default PopupApartmentInfo;
